<!--
Copyright 2020 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <li v-if="!loggedIn" id="navbar-actions">
    <a href="#" @click.prevent>
      <span class="icon-user-circle-o"></span>{{ $t('notLoggedIn') }}
    </a>
  </li>
  <li v-else id="navbar-actions" class="dropdown">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button"
      aria-haspopup="true" aria-expanded="false">
      <span class="icon-user-circle-o"></span>
      <span>{{ currentUser.displayName }}</span>
      <span class="caret"></span>
    </a>
    <ul class="dropdown-menu">
      <li>
        <router-link id="navbar-actions-edit-profile" to="/account/edit">
          {{ $t('action.editProfile') }}
        </router-link>
      </li>
      <li>
        <a id="navbar-actions-log-out" href="#" @click.prevent="logOut">
          {{ $t('action.logOut') }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
import request from '../../mixins/request';
import { confirmUnsavedChanges } from '../../util/router';
import { logOut } from '../../util/session';
import { noop } from '../../util/util';
import { requestData } from '../../store/modules/request';

export default {
  name: 'NavbarActions',
  mixins: [request()],
  props: {
    loggedIn: {
      type: Boolean,
      default: false
    }
  },
  // The component does not assume that this data will exist when the component
  // is created.
  computed: requestData(['currentUser']),
  methods: {
    logOut() {
      if (confirmUnsavedChanges(this.$store)) {
        logOut(this.$router, this.$store, false)
          .then(() => {
            this.$alert().success(this.$t('alert.logOut'));
          })
          .catch(noop);
      }
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This text is shown if the user is not logged in. It is shown in the
    // navigation bar at the top of the page.
    "notLoggedIn": "Not logged in",
    "action": {
      "logOut": "Log out"
    },
    "alert": {
      "logOut": "You have logged out successfully."
    }
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "notLoggedIn": "Nepřihlášen",
    "action": {
      "logOut": "Odhlásit se"
    },
    "alert": {
      "logOut": "Úspěšně jste se odhlásili."
    }
  },
  "de": {
    "notLoggedIn": "Nicht angemeldet",
    "action": {
      "logOut": "Ausloggen"
    },
    "alert": {
      "logOut": "Sie haben erfolgreich ausgeloggt."
    }
  },
  "es": {
    "notLoggedIn": "No ha iniciado sesión",
    "action": {
      "logOut": "Cerrar sesión"
    },
    "alert": {
      "logOut": "Ha cerrado la sesión correctamente."
    }
  },
  "fr": {
    "notLoggedIn": "Non connecté",
    "action": {
      "logOut": "Se déconnecter"
    },
    "alert": {
      "logOut": "Vous avez été déconnecté avec succès."
    }
  },
  "id": {
    "notLoggedIn": "Belum masuk",
    "action": {
      "logOut": "Keluar"
    },
    "alert": {
      "logOut": "Anda sudah berhasil keluar."
    }
  },
  "ja": {
    "notLoggedIn": "ログイン",
    "action": {
      "logOut": "ログアウト"
    },
    "alert": {
      "logOut": "ログアウトに成功しました。"
    }
  }
}
</i18n>
